import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import type { FileProvidersFilter } from '../store/schema/FileProvidersFilter';
import getAddedProviders from '../utils/getAddedProviders';
import getDefaultFileProvider from '../actions/helpers/getDefaultFileProvider';
import type { FileSelectionFilter } from 'owa-fileprovider-store';

const changeSelectedFileProviderToDefault = (
    filter: FileSelectionFilter,
    providersFilter: FileProvidersFilter,
    previousFileSelectionFilter: FileSelectionFilter,
    previousProvidersFilter: FileProvidersFilter,
    viewState: FilePickerPanelViewState
) => {
    // Select a default provider if there is no selected file provider or the selection filter got changed.
    // If the selection filter did not change then we should show the same provider that the user selected
    // hence we don't change the provider to default.
    if (
        filter !== previousFileSelectionFilter ||
        providersFilter !== previousProvidersFilter ||
        !viewState.selectedFileProvider
    ) {
        const defaultProvider = getDefaultFileProvider(getAddedProviders(filter));
        changeSelectedFileProvider(defaultProvider, viewState);
    }
};

export default changeSelectedFileProviderToDefault;
